import type { ValueOf } from '../../types/ValueOf';

/**
 * Vendors used/configurable in discovery settings.
 */
export const vendorApiNames = {
  arubaNewCentral: 'aruba-new-central',
  aws: 'aws-ec2',
  azure: 'azure',
  checkpoint: 'checkpoint-mgmt-api',
  ciscoapic: 'ciscoapic',
  ciscofmc: 'ciscofmc',
  f5osa: 'f5os-a',
  f5osc: 'f5os-c',
  forcepoint: 'forcepoint',
  gcp: 'gcp',
  junipermist: 'juniper-mist',
  meraki: 'meraki',
  nsxT: 'nsxT',
  prisma: 'prisma',
  ruckusvsz: 'ruckus-vsz',
  silverpeak: 'silverpeak',
  velocloud: 'velocloud',
  versa: 'versa',
  viptela: 'viptela',
} as const;

// The hybrid discovery means that the network device is discovered primarily using CLI and for some tasks gets data using API.
export const hybridVendorApiNames = [
  vendorApiNames.checkpoint,
  vendorApiNames.ciscoapic,
  vendorApiNames.ciscofmc,
  vendorApiNames.forcepoint,
];

/**
 * Vendors generated at discovery time.
 */
export const mappedVendorApiNames = {
  illumio: 'illumio',
} as const;

export const allVendorApiNames = {
  ...vendorApiNames,
  ...mappedVendorApiNames,
} as const;

export type VendorApiType = ValueOf<typeof vendorApiNames>;
